import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { SessaoService } from '../services/sessao.service';
import { RestClientService } from '../services/restclient.service';
import { MensagemService } from '../services/mensagem.service';
import { LiquidacaoAntecipadaService } from '../services/liquidacaoantecipada.service';
import { Contrato } from '../modelo/contrato';
import { Config } from '../services/config';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { FormControl, FormGroup, Validators } from '@angular/forms';

declare var $: any;


interface DadosBancarios {
  cdContrato: number;
  cdBanco: number;
  cdAgencia: number;
  cdConta: number;
  cdDgConta: string;
  nuDddTelefone: string;
  nuTelefone: number;
  dsEmail: string;
  cdEtapa: number;
  nuCTRL: string;
}

interface DadosTela {
  cdBanco: number;
  dsAgencia: string;
  dsConta: string;
  dsTelefone: string;
  dsEmail: string;
}

@Component({
  selector: 'app-liquidacao-modal-dados-bancarios',
  templateUrl: './liquidacao-modal-dados-bancarios.component.html',
  styleUrls: ['./liquidacao.component.css'],
  providers: [LiquidacaoAntecipadaService, MensagemService, RestClientService]
})
export class LiquidacaoModalDadosBancariosComponent extends AbstractComponent implements OnInit {

  contrato: Contrato;
  etapaTela: number = 1;

  bancoList: any[] = [];
  
  dadosTela: DadosTela = {
    cdBanco: undefined,
    dsAgencia: "",
    dsConta: "",
    dsTelefone: "",
    dsEmail: ""
  }

  formDadosBancarios: FormGroup;

  bodyDadosBancarios: DadosBancarios = {
    cdAgencia: 0,
    cdContrato: 0,
    cdBanco: 0,
    cdConta: 0,
    cdDgConta: "",
    cdEtapa: 0,
    dsEmail: "",
    nuCTRL: "",
    nuDddTelefone: "",
    nuTelefone: 0,
  };

  constructor(
    private sessaoService: SessaoService,
    private liquidacaoAntecipadaService: LiquidacaoAntecipadaService,

    private mensagemService: MensagemService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<LiquidacaoModalDadosBancariosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(sessaoService);
  }

  ngOnInit() {
    this.contrato = JSON.parse(sessionStorage.getItem('liquidacaoContrato'));
    this.bodyDadosBancarios.cdContrato = this.contrato.nuContrato
    this.carregarListaBancos();

    this.formDadosBancarios = new FormGroup({
      cdBanco: new FormControl(this.dadosTela.cdBanco, [Validators.required, Validators.pattern('^[0-9]*$')]),
      dsAgencia: new FormControl(this.dadosTela.dsAgencia, [Validators.required, Validators.pattern('^[0-9]*$'), Validators.maxLength(5)]),
      dsConta: new FormControl(this.dadosTela.dsConta, [Validators.required, Validators.pattern('^[0-9]{1,13}-[0-9a-zA-Z]$'), Validators.maxLength(15)]),
      dsTelefone: new FormControl(this.dadosTela.dsTelefone, [Validators.required, Validators.maxLength(15), Validators.minLength(14)]),
      dsEmail: new FormControl(this.dadosTela.dsEmail, [Validators.required, Validators.email, Validators.maxLength(70)])      
    });
  }

  fechar() {
    this.dialogRef.close({
      event: 'success',
      data: this.bodyDadosBancarios,
    });
  }

  voltar(etapa: number) {
    this.etapaTela = etapa;
  }  

  onClickConfirmar(etapa: number): void {
    if (etapa == 1) {
      if (this.formDadosBancarios.valid) {
        this.validarDadosBancarios();
      } else {
        this.markFormGroupTouched(this.formDadosBancarios);
      }
    } else if (etapa == 2) {
      this.cadastrarDadosBancarios();
    } else {
      this.fechar();
    }
  }


  /**
   * Marca todos os campos do formulário como tocados
   * @param formGroup 
   */
  private markFormGroupTouched(formGroup: FormGroup) {
    formGroup.markAsTouched({ onlySelf: true });
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

   /**
   * Busca flag para checar se exibe mensagem de dados bancarios
   */
   carregarListaBancos() {
    $('.progress').show();
    this.liquidacaoAntecipadaService.listarBanco().subscribe(
      result => {
        var data = result
        var bancosTransformados = data.bancos.map(banco => ({
          value: banco.cdBanco,
          label: banco.nmBanco.trim()
      }));
        this.bancoList = bancosTransformados;
      },
      (error: Response) => {
        this.dialog.open(BraAlertComponent, {
          width: Config.POPUP_50VW,
          data: {
            mensagem: this.getMensagem("ERRO_CHAMADA_SERVICO")
          }
        });
      },
      () => {
        this.spinnerService.hide();
        $('.progress').hide();
      });
  }

  /**
   * Validar dados bancários
   */
  validarDadosBancarios() {

    this.bodyDadosBancarios.cdAgencia = Number(this.dadosTela.dsAgencia),
    this.bodyDadosBancarios.cdBanco = this.dadosTela.cdBanco,
    this.bodyDadosBancarios.cdConta = Number(this.dadosTela.dsConta.slice(0, -1).replace('-', '')), // Todos os dígitos, exceto o último
    this.bodyDadosBancarios.cdDgConta = this.dadosTela.dsConta.slice(-1), // Último dígito
    this.bodyDadosBancarios.dsEmail = this.dadosTela.dsEmail,
    this.bodyDadosBancarios.nuDddTelefone = this.dadosTela.dsTelefone.substring(1, 3),
    this.bodyDadosBancarios.nuTelefone = Number(this.dadosTela.dsTelefone.substring(5, 15).replace('-', ''))


    $('.progress').show();
    this.liquidacaoAntecipadaService.validarDadosClienteSeguro(this.bodyDadosBancarios).subscribe(
      result => {
        var data = result
        //cdMsgemRetorno: "8"
        //dsMsgemRetorno: "NAO HA CONTAS PARA O CPF INFORMADO    
        if (result && result.cdMsgemRetorno && result.cdMsgemRetorno == "8") {
          let mensagem_erro: String = "Conta inválida! Por favor, verifique os dados informados.";
          if (result && result.dsMsgemRetorno) {
            mensagem_erro = result.dsMsgemRetorno
          }
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: mensagem_erro
            }
          });
        } else {
          // Sucesso, seguir para próxima etapa
          this.etapaTela = 2;
        }

        
      },
      (error: Response) => {
        this.dialog.open(BraAlertComponent, {
          width: Config.POPUP_50VW,
          data: {
            mensagem: this.getMensagem("ERRO_CHAMADA_SERVICO")
          }
        });
      },
      () => {
        this.spinnerService.hide();
        $('.progress').hide();
      });
  }

 /**
   * Salvar dados bancários
   */
cadastrarDadosBancarios() {
  $('.progress').show();
  this.liquidacaoAntecipadaService.cadastrarDadosClienteSeguro(this.bodyDadosBancarios).subscribe(
    result => {
      var data = result
      this.etapaTela = 3;
    },
    (error: Response) => {
      //console.log(error)
      this.dialog.open(BraAlertComponent, {
        width: Config.POPUP_50VW,
        data: {
          mensagem: this.getMensagem("ERRO_CHAMADA_SERVICO")
        }
      });
    },
    () => {
      this.spinnerService.hide();
      $('.progress').hide();
    });
}  

onBlurGenerico(event: any,campo: string) {
  const value = event;
  // Adicione a lógica que você deseja executar ao sair do campo
  //console.log('Valor ao sair do campo AGENCIA:', value);

  // Aplicar a máscara manualmente
  let valorMascarado = value;
  if (campo === 'AGENCIA') {
    valorMascarado = value.replace(/\D/g, ''); // Remove caracteres não numéricos e limita a 5 dígitos
  } else if (campo === 'CONTA') {
    const numeros = value.replace(/-/g, ''); // Remove apenas o hífen
    if (numeros.length > 1) {
      valorMascarado = numeros.slice(0, -1) + '-' + numeros.slice(-1); // Formata como 99999-9
    } else {
      valorMascarado = numeros; // Caso tenha apenas um dígito, não adiciona o hífen
    }
  } else if (campo === 'TELEFONE') {
    const numeros = value.replace(/\D/g, '');
    if (numeros.length <= 10) {
      valorMascarado = `(${numeros.slice(0, 2)}) ${numeros.slice(2, 6)}-${numeros.slice(6, 10)}`; // Formata como (99) 9999-9999
    } else {
      valorMascarado = `(${numeros.slice(0, 2)}) ${numeros.slice(2, 7)}-${numeros.slice(7, 11)}`; // Formata como (99) 99999-9999
    }
    //valorMascarado = valorMascarado.slice(0, 15); // Limita a 15 caracteres
  }
  //console.log('Valor Mascarado:', valorMascarado);

  if (campo === 'AGENCIA') {
    this.dadosTela.dsAgencia = valorMascarado;
  } else if (campo === 'CONTA') {
    this.dadosTela.dsConta = valorMascarado;
  } else if (campo === 'TELEFONE') {
    this.dadosTela.dsTelefone = valorMascarado;
  }

  this.atualizarFormulario();

}

// Função para obter o nome do banco a partir do código
getNomeBanco(cdBanco: number): string | undefined {
  const banco = this.bancoList.find(b => b.value === cdBanco);
  return banco ? banco.label.trim() : undefined;
}

// Método para atualizar o formulário quando `this.dadosTela` muda
atualizarFormulario() {
  this.formDadosBancarios.patchValue({
    cdBanco: this.dadosTela.cdBanco,
    dsAgencia: this.dadosTela.dsAgencia,
    dsConta: this.dadosTela.dsConta,
    dsTelefone: this.dadosTela.dsTelefone,
    dsEmail: this.dadosTela.dsEmail
  });
}

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-liquidacao-cli/liquidacao-modal-dados-bancarios.component.ts